import React from 'react';
import { Link } from 'react-router-dom';
import { RingLoader } from 'react-spinners';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

function StatusRow({ screen }) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-invert-border last:border-0">
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-base shrink-0" aria-hidden="true">📍</span>
        <span className="text-sm font-medium text-invert-navy truncate">{screen.brand}</span>
      </div>
      <span className="text-xs font-semibold shrink-0 ml-3 text-emerald-600">
        🟢 Online
      </span>
    </div>
  );
}

export default function LiveNetworkStatus({ compact = false, showLink = true }) {
  const {
    screens,
    liveScreens,
    totalScreens,
    loading,
    error,
  } = useNetworkStatus();

  if (!loading && error && screens.length === 0) {
    return null;
  }

  const title = 'Live INVERT Network';

  return (
    <div
      className={`rounded-2xl border border-invert-border bg-white ${
        compact ? 'p-5' : 'p-6 lg:p-8'
      }`}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-invert-navy">{title}</h3>
        {!loading && totalScreens > 0 && !error && (
          <span className="text-xs font-semibold uppercase tracking-wider text-invert-orange">
            {liveScreens || totalScreens} live
          </span>
        )}
      </div>

      {loading && (
        <div className="flex justify-center py-8" aria-live="polite">
          <RingLoader color="#dc5024" loading size={32} aria-label="Loading network status" />
        </div>
      )}

      {!loading && screens.length === 0 && (
        <p className="text-sm text-slate-500 py-4">Screens are joining the network soon.</p>
      )}

      {!loading && screens.length > 0 && (
        <div className={compact ? 'max-h-64 overflow-y-auto' : ''}>
          {screens.map((screen) => (
            <StatusRow key={screen.screenId} screen={screen} />
          ))}
        </div>
      )}

      {!loading && totalScreens > 0 && (
        <p className="text-sm text-slate-500 mt-4 pt-4 border-t border-invert-border">
          {liveScreens || totalScreens} of {totalScreens} screens live right now
        </p>
      )}

      {showLink && (
        <Link
          to="/proof"
          className="inline-block mt-4 text-sm font-semibold text-invert-orange hover:text-invert-orange-deep transition-colors"
        >
          See full proof →
        </Link>
      )}
    </div>
  );
}
